var AnonymousAuthProvider = (function () {
    function AnonymousAuthProvider() {
    }
    AnonymousAuthProvider.TYPE = "anon-user";
    AnonymousAuthProvider.DEFAULT_NAME = "anon-user";
    return AnonymousAuthProvider;
}());
export default AnonymousAuthProvider;
//# sourceMappingURL=AnonymousAuthProvider.js.map